<script setup>
import { ref, defineProps, onMounted } from 'vue'
import PlaceInformation from '@/components/object_placeCollection/templates/placeInformation.vue'
import { formatDate } from '@/mixins/global/globalPlaces'

const props = defineProps({
    placeInformation: {
        type: Object,
        default: null
    }
})

const dayDate = ref('')
const activePlaces = ref([])

onMounted(() => {
    if (props.placeInformation && Object.keys(props.placeInformation).length > 0) {
        const today = new Date().toISOString().split('T')[0]

        const availableDates = Object.keys(props.placeInformation).sort()

        if (availableDates.includes(today)) {
            dayDate.value = today
        } else {
            dayDate.value = availableDates[0]
        }

        activePlaces.value = props.placeInformation[dayDate.value]?.places ?? []
    }
})
</script>

<template>
    <div class="day-overview-container">
        <div v-if="!placeInformation || Object.keys(placeInformation).length === 0" class="places-empty">
            Keine Platzinformationen verfügbar.
        </div>

        <template v-else>
            <div v-if="dayDate" class="day-date-header">
                Platzstatus am {{ formatDate(dayDate, true) }}
            </div>

            <div class="places">
                <div v-for="(place, index) in activePlaces"
                     :key="index"
                     class="place-status-box"
                     :class="{ 'open': place.open, 'closed': !place.open }">
                    <div class="place-header">
                        <span class="place-name">{{ place.name }}</span>
                    </div>
                    <place-information :place="place"/>
                </div>
            </div>
        </template>
    </div>
</template>

<style scoped lang="scss">
.day-date-header {
    margin-bottom: 1rem;
}

.places {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 1rem;
}

.place-status-box {
    border: 1px solid #eeeeee;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
}

.place-header {
    padding: 0.5rem 1rem;
    border-bottom: 1px solid #eeeeee;
}

.place-name {
    font-weight: 600;
}

.place-info {
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
}

.status-label {
    font-weight: 600;
}

.place-description {
    color: #7d7d7d;
}

@media (max-width: 60em) {
    .place-status-box {
        width: 100%;
    }
}
</style>
